<template>
	<div class="sidebar-image-editor">
		<iframe :src="src" id="iframe-mam-search" class="-iframe" ref="search">
		</iframe>
	</div>
</template>
<script>
export default {
	name: 'ErcoSidebarImageLoaderMolecule',

	props: {
		data: {
			type: Object,
		},
	},

	computed: {
		src() {
			let src = process.env.GET_MAM_IMAGE_SEARCH_URL;
			src += `&jwt=${this.token}`;
			return src;
		},

		token() {
			return this.$store.state.user.token;
		},

		context() {
			return this.$store.state.sidebar.context;
		},
	},

	mounted() {
		window.addEventListener('message', this.onReceive, false);

		this.$refs.search.onload = function onload() {
			this.contentWindow.postMessage('init', process.env.STAGING_SERVER);
			this.onload = null;
		};
	},

	destroyed() {
		window.removeEventListener('message', this.onReceive);
	},

	methods: {

		onReceive(event) {
			if (event.origin === process.env.STAGING_SERVER) {
				const context = Object.assign({}, this.$store.state.sidebar.context);
				context.value = {
					...context.value,
					PKM_Seite: this.data.FKM_Seite,
					U_Position: this.data.U_Position,
					sprache: this.data.S_Sprachkuerzel,
					...event.data,
				};
				this.$store.dispatch('updateSidebar', { doTrack: false, context });
			}
		},
	},
};
</script>
<style lang="scss">
.sidebar-image-editor {
	.-iframe {
		height: 70vh;
		width: 100%;
		border: 0;
		overflow-y: scroll;
	}
}
</style>



// WEBPACK FOOTER //
// ImageLoader.vue?164e98eb